/**
 * What a piece of feedback is about. Mirrors `FeedbackContextType` in
 * `api/src/domain/feedback/Feedback.ts` — keep the two in sync.
 */
export enum FeedbackContextType {
  ChatResponse = 'chat_response',
  CompetitorSuggestion = 'competitor_suggestion',
  ContactLabelSuggestion = 'contact_label_suggestion',
  Signal = 'signal',
  SignalSuggestion = 'signal_suggestion',
  Ui = 'ui',
}

export enum FeedbackStatus {
  Actioned = 'actioned',
  Captured = 'captured',
  Dismissed = 'dismissed',
  Triaged = 'triaged',
}

/** Thumbs down and thumbs up as the 0–1 rating the API stores. */
export const FEEDBACK_RATING_DOWN = 0;
export const FEEDBACK_RATING_UP = 1;

export interface Feedback {
  accountId: number;
  comment?: null | string;
  contextData?: null | Record<string, unknown>;
  contextKey?: null | string;
  contextType: FeedbackContextType;
  createdAt: Date;
  id: number;
  rating?: null | number;
  screenshotS3Key?: null | string;
  status: FeedbackStatus;
  updatedAt: Date;
  userId: number;
}

/** Request body for `POST /feedback`. */
export interface CreateFeedbackInput {
  comment?: null | string;
  contextData?: null | Record<string, unknown>;
  contextKey?: null | string;
  contextType: FeedbackContextType;
  rating?: null | number;
  /** Key returned by `POST /feedback/screenshot`. */
  screenshotS3Key?: null | string;
}
